import { useTheme } from 'styled-components';

export interface ValidCheckIconProps {
  className?: string;
}

export const ValidCheckIcon: React.FC<ValidCheckIconProps> = ({ className }) => {
  const theme = useTheme();
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.48079 12.7852C5.16005 13.0716 7.83996 13.0716 10.5192 12.7852C11.611 12.6582 12.6587 11.6111 12.7852 10.5192C13.0716 7.83995 13.0716 5.16005 12.7852 2.48079C12.6582 1.38896 11.6111 0.341824 10.5192 0.214809C7.83996 -0.0716032 5.16005 -0.0716032 2.48079 0.214809C1.38845 0.340751 0.341304 1.38789 0.214809 2.48027C-0.0716032 5.15953 -0.0716032 7.83944 0.214809 10.5187C0.341767 11.6105 1.3889 12.6577 2.48079 12.7847V12.7852ZM2.63162 5.52276C3.03889 5.15763 3.66454 5.19165 4.0302 5.59893L5.52525 7.26559L8.98818 3.59348C9.36346 3.19535 9.99012 3.17707 10.3878 3.55235C10.7859 3.92763 10.8042 4.55429 10.4289 4.95198L6.2272 9.40762C6.04032 9.60617 5.7793 9.71841 5.50709 9.71841H5.49491C5.21763 9.71485 4.95509 9.59551 4.76973 9.38934L2.55562 6.92134C2.19049 6.51406 2.22452 5.88841 2.6318 5.52275L2.63162 5.52276Z"
        fill={theme.extraColors.greenIndicator}
      />
    </svg>
  );
};
